import { render, staticRenderFns } from "./DivergenciaDadosIndicadoresIcon.vue?vue&type=template&id=b5ec8d5e"
import script from "./DivergenciaDadosIndicadoresIcon.vue?vue&type=script&lang=js"
export * from "./DivergenciaDadosIndicadoresIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports